import { OnInit } from '@angular/core';
import { UXPage } from '../../../core/models/ux-page';
var PagePageComponent = /** @class */ (function () {
    function PagePageComponent() {
    }
    PagePageComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(PagePageComponent.prototype, "pageFound", {
        get: function () {
            return !!this.page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "hasVideos", {
        get: function () {
            if (this.page && this.page.videos && this.page.videos.length) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "videoUrl", {
        get: function () {
            return this.page.videos[0].videoUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "videoQuery", {
        get: function () {
            return this.page.videos[0].query;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "videoAttr", {
        get: function () {
            return this.page.videos[0].attr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "hasPageDecoration", {
        get: function () {
            return this.page &&
                ((!!this.page.banner && !!this.page.banner.img)
                    || !!this.page.blocks.length
                    || !!this.page.introText);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "hasBlocksGroups", {
        get: function () {
            if (this.page && this.page.blocksGroups && this.page.blocksGroups.length) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagePageComponent.prototype, "blocksGroups", {
        get: function () {
            return this.page.blocksGroups;
        },
        enumerable: true,
        configurable: true
    });
    return PagePageComponent;
}());
export { PagePageComponent };
